// The categories a visitor can allow in the cookie banner, each on its own.
// Strictly necessary cookies need no consent, so they are not among them.
// - analytics and marketing allow their tracking pixels (see categoryTrackers).
// - embedded lets Calendly, Vimeo and Whereby embeds load without asking;
//   without it, each embed asks for its own consent.
export const CATEGORIES = ['analytics', 'marketing', 'embedded'];

// "Accept all" allows every category, "Reject all" none, and "Save my
// choices" the ones picked in the settings view.
export function decisionCategories(decision, customCategories = []) {
    if (decision === 'accepted') return [...CATEGORIES];
    if (decision === 'declined') return [];
    if (decision === 'custom') return CATEGORIES.filter((category) => customCategories.includes(category));
    throw new Error(`Unknown cookie consent decision: ${decision}`);
}

// The categories the stored cookies currently allow.
export function currentCategories({ trackers, functional }, categoryTrackers) {
    return CATEGORIES.filter((category) =>
        category === 'embedded'
            ? functional
            : (categoryTrackers[category] ?? []).some((tracker) => trackers.includes(tracker)),
    );
}

// How to apply a choice, given the categories the previous one allowed.
export function planChoice(previous, next, categoryTrackers) {
    const granted = next.filter((category) => !previous.includes(category));
    const revoked = previous.filter((category) => !next.includes(category));
    const trackersOf = (categories) => categories.flatMap((category) => categoryTrackers[category] ?? []);

    return {
        // Nothing the visitor newly allows may start before their consent is on record.
        recordFirst: granted.length > 0,
        // Trackers and embeds loaded under the earlier choice stay on the page until it reloads.
        reload: revoked.length > 0,
        startTrackers: trackersOf(granted),
        startEmbedded: granted.includes('embedded'),
        cookies: {
            trackers: trackersOf(next),
            functional: next.includes('embedded'),
        },
    };
}
